/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TaskSuggestionStatusType = {
    Pending: 'Pending',
    Accepted: 'Accepted',
    Rejected: 'Rejected'
} as const;
export type TaskSuggestionStatusType = typeof TaskSuggestionStatusType[keyof typeof TaskSuggestionStatusType];


export function TaskSuggestionStatusTypeFromJSON(json: any): TaskSuggestionStatusType {
    return TaskSuggestionStatusTypeFromJSONTyped(json, false);
}

export function TaskSuggestionStatusTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskSuggestionStatusType {
    return json as TaskSuggestionStatusType;
}

export function TaskSuggestionStatusTypeToJSON(value?: TaskSuggestionStatusType | null): any {
    return value as any;
}

